var map = {
	"./account.js": "61c5",
	"./analysis.js": "3daa",
	"./autoDiscount.js": "8f7d",
	"./common.js": "c459",
	"./default.js": "10e2",
	"./externalPlatform.js": "144a",
	"./manualDiscount.js": "291a",
	"./marquee.js": "d59f",
	"./meal.js": "754d",
	"./media.js": "1c3a",
	"./news.js": "611b",
	"./notification.js": "779a",
	"./order.js": "2bf4",
	"./ownProductCategory.js": "fc3b",
	"./permission.js": "31c2",
	"./permissionManagement.js": "9e28",
	"./product.js": "c2ff",
	"./report.js": "62d4",
	"./shopSystem.js": "6aa8",
	"./storeGift.js": "334f",
	"./storeGiftRecord.js": "a5ab",
	"./systemPreferences.js": "25f6",
	"./user.js": "0f9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c653";